/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ImportHistoricalEvalResultsRequest = {
  /**
   * Caller-owned Hugging Face token with read access to the source dataset repository. Gateway does not use its server-side Hugging Face token for historical imports.
   */
  xHuggingFaceToken: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  importHistoricalEvalResultsRequest:
    components.ImportHistoricalEvalResultsRequest;
};

/** @internal */
export const ImportHistoricalEvalResultsRequest$inboundSchema: z.ZodType<
  ImportHistoricalEvalResultsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-HuggingFace-Token": z.string(),
  "X-On-Behalf-Of": z.string().optional(),
  ImportHistoricalEvalResultsRequest:
    components.ImportHistoricalEvalResultsRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "X-HuggingFace-Token": "xHuggingFaceToken",
    "X-On-Behalf-Of": "xOnBehalfOf",
    "ImportHistoricalEvalResultsRequest": "importHistoricalEvalResultsRequest",
  });
});
/** @internal */
export type ImportHistoricalEvalResultsRequest$Outbound = {
  "X-HuggingFace-Token": string;
  "X-On-Behalf-Of"?: string | undefined;
  ImportHistoricalEvalResultsRequest:
    components.ImportHistoricalEvalResultsRequest$Outbound;
};

/** @internal */
export const ImportHistoricalEvalResultsRequest$outboundSchema: z.ZodType<
  ImportHistoricalEvalResultsRequest$Outbound,
  z.ZodTypeDef,
  ImportHistoricalEvalResultsRequest
> = z.object({
  xHuggingFaceToken: z.string(),
  xOnBehalfOf: z.string().optional(),
  importHistoricalEvalResultsRequest:
    components.ImportHistoricalEvalResultsRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    xHuggingFaceToken: "X-HuggingFace-Token",
    xOnBehalfOf: "X-On-Behalf-Of",
    importHistoricalEvalResultsRequest: "ImportHistoricalEvalResultsRequest",
  });
});

export function importHistoricalEvalResultsRequestToJSON(
  importHistoricalEvalResultsRequest: ImportHistoricalEvalResultsRequest,
): string {
  return JSON.stringify(
    ImportHistoricalEvalResultsRequest$outboundSchema.parse(
      importHistoricalEvalResultsRequest,
    ),
  );
}
export function importHistoricalEvalResultsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ImportHistoricalEvalResultsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ImportHistoricalEvalResultsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ImportHistoricalEvalResultsRequest' from JSON`,
  );
}
